<template>
  <div class="sectionPlayerContainer" >
    <div :class=" mirroring?'videoMirroring':'full'">
      <div :style="'background-image: url('+main+');'" class="thumbnail" :class="filterMainClass+' noAnimation '"></div>
      <div class="mask"></div>
      <div class="layer1"></div>
      <div class="layer2"></div>
      <div class="layer3"></div>
      <div class="layer4"></div>
      <div class="layer5"></div>
    </div>
    <div class="blackOverlay" :class="{processing:isProcessing,selected:selectedSegement===segment}" >
    </div>
    <div class="sticker" :style="'background-image:url('+ urlUser+')'" v-if="second!=='' && this.mustShowSticker">
      <div class="videoMirroring">
        <div :style="'background-image: url('+second+');'" class="thumbnail"
             :class="filterStickerClass+' noAnimation'"></div>
        <div class="mask"></div>
        <div class="layer1"></div>
        <div class="layer2"></div>
        <div class="layer3"></div>
        <div class="layer4"></div>
        <div class="layer5"></div>
      </div>
    </div>

    <transition name="fade">
      <div class="playLayout" v-show="mainProgress>=100" >
        <w-icon icon="play-circle" size="default"/>
      </div>
    </transition>


    <!-- progress bar -->
      <div class="pourcentageValue" v-show="isProcessing">{{ mainProgressLabel }}</div>
      <div class="progressBar" :style="{width:mainProgress+'%'}"  v-show="isProcessing"></div>
  </div>
</template>


<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WIcon from "@/components/wrapper/w-icon.vue";
import { Segment, TimeEvent } from "@/store/timeLine/timeEvent";
import { Media } from "@/store/media/mediaModel";
import { getImageURLForSize, getThumbnailURL, getUserAvatar, isImageExists } from "@/utils/util";
import UserAvatar from "@/components/user/UserAvatar.vue";
import { StickerPosition } from "@/enum/StickerPositionEnum";
import { SourceVideoType } from "@/enum/SourceVideoEnum";
import store from "@/store";
import { getTimeEventExactTime } from "@/utils/timeLineUtils";
import delay from "delay";

@Component({
  components: {UserAvatar, WIcon}
})
export default class ImageSection extends Vue {

  @Prop()
  private segment!: Segment;

  @Prop({default: false})
  private autoplay!: boolean;
  private mustShow: boolean = false;

  private main: string = '';
  private mainProgress: number = 0;
  private isProcessing: boolean = false;
  private second: string = '';
  private urlUser: string = '';
  private mustShowSticker: boolean = true;
  private MAX_ITERATION = 10;
  private indexTimeOut: any = 0;
  private filterStickerClass: string = '';
  private filterMainClass: string = '';
  private mirroring: boolean = false;


  public mounted() {
    this.mustShow = true;
    this.setupTheEventForTime();
  }

  get medias(): Media[] {
    return store.getters.getMedias;
  }

  get mainProgressLabel(): string {
    if (this.mainProgress === 0) {
      return this.$t('createWeetComponent.queued').toString();
    } if(this.mainProgress<=-1){
      return this.$t('createWeetComponent.errorProcessing').toString()
    } else {
      return this.mainProgress + " %";
    }
  }

  get selectedSegement():Segment|null{
    return store.getters.getSelectedSegment
  }

  @Watch('medias')
  private setupTheEventForTime() {
    const listEvent = store.getters.getTimeEvent;

    const updatedEvent = getTimeEventExactTime(listEvent, this.segment.start.time);
    if (updatedEvent) {
      this.setupThisEvent(updatedEvent);
    }

    if (updatedEvent?.mainMedia) {
      const media = store.getters.getMediasForMediaId(updatedEvent.mainMedia.mediaID) as Media;
      if (media) {
        this.mainProgress = media.progress;
        this.isProcessing = media.status !== "HD";
      }
    }
    if(!this.isProcessing && updatedEvent?.secondMedia){
      const media = store.getters.getMediasForMediaId(updatedEvent.secondMedia.mediaID) as Media;
      if (media) {
        this.mainProgress = media.progress;
        this.isProcessing = media.status !== "HD";
      }
    }
  }


  private async imageUrlToBase64(url):Promise<string> {
    // 1. Fetch the image
    const response = await fetch(url);

    // 2. Convert the response to a Blob
    const blob = await response.blob();

    // 3. Convert the Blob to Base64 using a FileReader
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result+""); // Base64 string
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  private async setupThisEvent(timeEvent: TimeEvent,maxTry=6) {
    if(maxTry<=0){
      return;
    }
    if(!this.main) {

      const urlMain = await this.getUrlMedia(timeEvent.mainMedia.mediaID, true);

      if (urlMain) {
        try {
          // waiting image readys
          this.main = await this.imageUrlToBase64(urlMain);
        }catch (e){
          await delay(2000);
          maxTry--;
          this.setupThisEvent(timeEvent,maxTry)
        }
      }
    }
    this.mustShowSticker = timeEvent.positionLayout === StickerPosition.BOTTOM_LEFT;
    if(!this.second) {
      const urlSecond = await this.getUrlMedia(timeEvent.secondMedia.mediaID, false);
      if (urlSecond) {
        try {
          this.second = await this.imageUrlToBase64(urlSecond);
        }catch (e){
          await delay(2000);
          maxTry--;
          this.setupThisEvent(timeEvent,maxTry)
        }
      }
    }
    if (timeEvent.secondMedia && timeEvent.secondMedia.mediaID) {
      this.filterStickerClass = timeEvent.secondMedia.filter;
    }
    if (timeEvent.mainMedia && timeEvent.mainMedia.mediaID) {
      this.filterMainClass = timeEvent.mainMedia.filter;

    }
    this.urlUser = this.getUrlUser(timeEvent.secondMedia.mediaID);
  }

  private async getUrlMedia(mediaId: string, main: boolean): Promise<string | undefined> {
    if (!mediaId) {
      return undefined;
    }
    for (const media of this.medias) {
      if (media.mediaID === mediaId) {
        if (main && media.type === SourceVideoType.WEBCAM) {
          this.mirroring = true;
        }
        if (media.imageBlobURL) {
          return media.imageBlobURL;
        } else {
          if(media.exportStaticUrl) {
            return getImageURLForSize(media.exportStaticUrl, 250);
          }
          else if (!media.jobID) {
            // so we wait have a blob ready or an status ready
            if (this.MAX_ITERATION > 0) {
              clearTimeout(this.indexTimeOut);
              this.indexTimeOut = setTimeout(this.setupTheEventForTime, 500);
              this.MAX_ITERATION--;
            }
            return undefined;
          } else {

              const urlImage = getThumbnailURL(media.jobID, true);
              if (media.status === 'HD') {
                return urlImage;
              } else {

                if (await isImageExists(urlImage)) {
                  return urlImage;
                } else {
                  return undefined;
                }
            }
          }
        }
      }
    }
  }


  private getUrlUser(mediaId: string): string {
    for (const media of this.medias) {
      if (media.mediaID === mediaId) {
        return getUserAvatar(media.creator, 48);
      }
    }
    return '';
  }
}
</script>


<style scoped lang="scss">
@import '@/scss/gridBreakPoint.scss';
@import '@/scss/shadows.scss';


.sectionPlayerContainer {
  height: 100%;
  width: 100%;
  position: relative;
  background: var(--dark);
  border-radius: 4px;
  overflow: hidden;

  .thumbnail {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .videoMirroring {
    width: 100%;
    height: 100%;
    transform: scale3d(-1, 1, 1);
  }

  .full {
    width: 100%;
    height: 100%;
  }

  .sticker {
    position: absolute;
    bottom: 4px;
    left: 4px;
    width: 24px;
    height: 24px;
    background-size: cover;
    // border: 1px solid white;
    @extend .stickersShadow;
    overflow: hidden;
    border-radius: 100% 100% 100% 4px;

    .videoMirroring {
      width: 24px;
      height: 24px;

      .videoElement {
        width: 24px;
        height: 24px;
        object-fit: cover;
      }
    }
  }

  .playLayout {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }

  .pourcentageValue {
    position: absolute;
    width: 100%;
    color: white;
    text-align: center;
    bottom: 24px;
    font-weight: 900;
    left: 4px;
    font-size: 12px;
  }

  .progressBar {
    position: absolute;
    width: 100%;
    height: 3px;
    background: var(--primary);
    bottom: 0;
    left: 0;
  }

  .blackOverlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    transition: background-color 0.2s ease-in-out;
    background: rgba(0, 0, 0, 0.3);
    &.selected{
      background: rgba(0,0, 255, 0.3);
    }
    &.processing {
      background: rgba(0, 0, 0, 0.5);
    }
  }

  &:hover {
    opacity: 0.8;

    .blackOverlay{
      background: rgba(0,0, 255, 0.3);
    }
  }

}


</style>
